/**
 * Translation keys for master data module.
 * Keys are german default translations.
 */
export const KEYS = {
  SEARCH: {
    // standard field labels
    GENDER: 'Geschlecht',
    MALE: 'Männlich',
    FEMALE: 'Weiblich',
    DIVERSE: 'Divers',
    FIRSTNAME: 'Vorname',
    LASTNAME: 'Nachname',
    BIRTHDATE: 'Geburtsdatum',
    ADDRESS: 'Adresse',
    ADDRESS_DEPRECATED: 'Adresse (veraltet)',
    ZIP_CODE: 'PLZ',
    CITY: 'Ort',
    STREET: 'Straße',
    STREET_NR: 'Hausnummer',
    LOCATION: 'Standort',
    EMAIL: 'E-Mail',
    ID: 'Patientennummer',
    CASE_NUMBER: 'Fallnummer',
    PSEUDO_ID: 'Pseudo Id',
    STATUS: 'Status',
    LANGUAGE: 'Sprache',
    ALLOW_MAIL_OPTION: 'E-Mail Option',
    PREFILL: 'Vorausfüllen',
    OPTIONAL: 'Optional',
    YES: 'Ja',
    NO: 'Nein'
  },
  RENDERER: {
    ANONYMOUS: 'Anonym',
    PSEUDONYMOUS: 'Pseudonymisiert'
  }
};
